import Api from "../utils/axios";

const PreSetMessages = {
    getAllPreMessages: () => Api.get(`vendor/get-vendor-presuggestion`)
}

export default PreSetMessages